import {Injectable} from '@angular/core';
import {LanguageService} from './language.service';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class BrowserLanguageService extends LanguageService {
  constructor(protected translationService: TranslateService) {
    super();
  }

  setCurrentLanguage(locale: string) {
    const lang = locale || (navigator && navigator.languages && navigator.languages[0]);
    if (!lang) { return; }

    for (const language of this.translationService.getLangs()) {
      if (language.startsWith(lang.split('_')[0])) {
        this.translationService.setDefaultLang(language);
        break;
      }
    }
  }
}
